import type { ReactElement } from 'react';
import { Tooltip } from '@mantine/core';

/** Wrap a (possibly disabled) control with the reason it's disabled. */
export function ReasonTooltip({
  reason,
  children,
}: {
  reason: string | null | false | undefined;
  children: ReactElement;
}) {
  if (!reason) return children;
  return (
    <Tooltip label={reason} multiline maw={260}>
      <span style={{ display: 'inline-block' }}>{children}</span>
    </Tooltip>
  );
}
